import { useQuery } from 'react-query';
import { getTherigyContent } from 'App/services/ReportEngineService';
import * as R from 'ramda';

function useFetchTherigyInsightsContent() {
    return useQuery(
        ['insights', 'therigy'],
        () =>
            getTherigyContent().then(
                R.compose(
                    R.sortBy(R.prop('name')),
                    R.map(R.over(R.lensProp('dashboards'), R.sortBy(R.prop('title')))),
                    R.values
                )
            ),
        {
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
        }
    );
}

export default useFetchTherigyInsightsContent;
